import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/store/AuthContext";


// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      setError("Missing session id in callback URL.");
      return;
    }

    (async () => {
      try {
        await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true },
        );
        // Load the full user (includes has_onboarded, is_premium) — critical for
        // first-time onboarding routing in App.js.
        await checkAuth();
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true });
      } catch (e) {
        setError(e?.response?.data?.detail || e.message || "Sign-in failed");
      }
    })();
  }, [location.hash, navigate, checkAuth]);

  return (
    <div className="min-h-screen bg-paper flex items-center justify-center px-6" data-testid="auth-callback">
      <div className="card-editorial p-10 flex flex-col items-center gap-4 max-w-md text-center">
        {!error ? (
          <>
            <Loader2 className="animate-spin text-terracotta" size={40} />
            <h1 className="font-serif text-3xl text-stone-900">Bringing you in…</h1>
            <p className="text-sm text-stone-500">Confirming your Google session.</p>
          </>
        ) : (
          <>
            <h1 className="font-serif text-3xl text-stone-900">Sign-in didn&apos;t complete.</h1>
            <p className="text-sm text-stone-500">{error}</p>
            <button onClick={() => (window.location.href = "/")} className="btn-outline mt-2">
              Back to Cadence
            </button>
          </>
        )}
      </div>
    </div>
  );
}
